import * as React from "react";

import {NewPasswordForm} from "../components/NewPasswordForm";
import {fullWidthViewHolder} from "./LoginView";

export const NewPasswordView = () => {
    return (
        <div css={fullWidthViewHolder}>
            <NewPasswordForm />
        </div>
    );
};
